import { useState, useEffect } from 'react';

export default function useDebounce(value: string | undefined, delay = 300): string {
  const [debouncedValue, setDebouncedValue] = useState<string>(value || '');

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value || '');
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
